import { PureComponent } from "react";

import image from "assets/img/reports-new/upsell/upgrade.png";
import { trackUpgradeButtonClicked, trackUpsellViewDisplayed } from "helpers/analytics-reports";

import { LinkButton } from "./components";
import {
  buttonStyles,
  contentWrapper,
  description,
  featureBox,
  featureDescription,
  featureHeader,
  features,
  header,
  headerWrapper,
  imageWrapper,
} from "./styled/upgrade";

export default class Upgrade extends PureComponent {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    trackUpsellViewDisplayed("Upgrade");
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <div css={contentWrapper}>
        <div css={imageWrapper}>
          <img src={image} width="480" height="238" />
        </div>
        <div css={headerWrapper}>
          <div css={header}>Stay on track with your business goals</div>
          <div css={description}>Upgrade your plan to view Reports.</div>
          <LinkButton
            href="/subscription"
            css={buttonStyles}
            onClick={() => trackUpgradeButtonClicked("Reports upgrade")}
          >
            Upgrade plan
          </LinkButton>
        </div>
        <div css={features}>
          <div css={featureBox}>
            <div css={featureHeader}>Get sales and happy customers</div>
            <div css={featureDescription}>
              <p>
                Check which chats ended with a sale and how your customers rated them. Learn from successful chats to
                make each conversation better.
              </p>
            </div>
          </div>
          <div css={featureBox}>
            <div css={featureHeader}>Never miss an opportunity</div>
            <div css={featureDescription}>
              <p>
                See what greetings convert best and fine-tune ones that aren’t doing so well. Follow up on customers who
                left the queue to show that you care.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
